<div class="tabbable__body margin--none shadow-z-1">
  @if(initiated) {
    <form (ngSubmit)="update()">
      @for(settingGroup of editableSettings; track $index) {
        <h3>{{settingsGroupHeader(settingGroup)}}</h3>
        @for(settingName of settingsGroupSettings(settingGroup); track $index) {
          <div class="input__container">
            <label>{{settingLabel(settingGroup, settingName)}}</label>
            <input id={{settingName}} type="number" name={{settingName}} [(ngModel)]="settings[settingName]">
          </div>
        }
        <div class="divider medium margin-top-bottom--4x"></div>
      }

      @if(settings?.feature_toggles?.length) {
        <h3>Feature toggles</h3>
        @for(feature_toggle of settings.feature_toggles; track $index) {
          <h5 class="thin">{{toggleLabel(feature_toggle.id, feature_toggle.name)}}</h5>
          <toggle
            [(ngModel)]="feature_toggle.on"
            name={{feature_toggle.id}}
            offLabel="Av"
            onLabel="På">
          </toggle>
        }
        <div class="divider medium margin-top-bottom--4x"></div>
      }

      <div>
        <h3>ERP-migrering</h3>
        <div class="input__container">
          <label>Första månaden för generering av ERP intäktsfiler (ÅÅÅÅ-MM)</label>
          <input id="erp_first_month" type="month" name="erp_first_month" [(ngModel)]="settings.erp_first_month">
        </div>
      </div>
      <div class="divider medium margin-top-bottom--4x"></div>

      <div>
        <h3>Schemalägg paus av fakturering</h3>
        <div class="padding-bottom--1x">
          <toggle
            [(ngModel)]="showPauseInvoices"
            (ngModelChange)="togglePauseInvoices()"
            name="'pause-invoices-checkbox'"
            offLabel="Av"
            onLabel="På">
          </toggle>
        </div>
        @if(showPauseInvoices) {
          <p>Fakturering stängs alla datum inklusive start och slutdatum.</p>
          <period-select
            [ngModel]="{start: settings.invoice_pause_start_date, end: settings.invoice_pause_end_date}"
            (ngModelChange)="pauseInvoicesPeriodChanged($event)"
            name="pauseInvoices"
          ></period-select>
        }
      </div>
      <div class="divider medium margin-top-bottom--4x"></div>
          <button type="Submit" class="button margin-top--3x" wooLoad>Spara</button>
      </form>
  }
</div>